import React, { FC, memo, useMemo } from 'react';
import { isNumber } from 'src/util/core';
import styled from 'styled-components';
import UdeskLocales from 'UdeskLocales';

const Wrapper = styled.div`
    margin-top: 8px;
    background-color: #eee;
    padding: 8px;
    font-size: 12px;
`;

const Title = styled.div`
    color: ${(props) => (props.isOcrSuccess ? '#52c41a' : '#ff4d4f')};
`;

const Content = styled.div`
    color: #ccc;
    white-space: pre-wrap;
`;

interface TemplateProps {
    ocrSuccess?: number;
    text?: string;
    forwardRef?: React.Ref<HTMLDivElement>;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { ocrSuccess, text, forwardRef } = props;

    const { hasOcr, isOcrSuccess } = useMemo(() => {
        return {
            hasOcr: isNumber(ocrSuccess),
            isOcrSuccess: ocrSuccess === 1,
        };
    }, [ocrSuccess]);

    return hasOcr ? (
        <Wrapper>
            <Title isOcrSuccess={isOcrSuccess}>
                {isOcrSuccess
                    ? /* 图片识别成功 */ UdeskLocales['current'].components.chatRecord
                          .chatRecordItem.components.imageRecognition.index
                          .imageRecognitionSuccessful
                    : /* 图片识别失败 */ UdeskLocales['current'].components.chatRecord
                          .chatRecordItem.components.imageRecognition.index.imageRecognitionFailed}
            </Title>

            {isOcrSuccess ? <Content ref={forwardRef}>{text}</Content> : null}
        </Wrapper>
    ) : null;
});

export default Template;
